import React from 'react';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { H } from './design-tokens';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';

interface HeaderMobileTriggerProps {
  onClick: () => void;
}

export const HeaderMobileTrigger: React.FC<HeaderMobileTriggerProps> = ({ onClick }) => {
  const { spacing } = useResponsiveSizes();
  return (
    <Button
      type='text'
      icon={<MenuOutlined style={{ fontSize: 20, color: H.text }} />}
      onClick={onClick}
      style={{ margin: `0 ${spacing.xxl}px` }}
    />
  );
};
